var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.452 21.6772C19.693 22.2156 19.528 22.8555 19.025 23.1639C17.126 24.3285 14.891 25 12.5 25C5.596 25 0 19.4035 0 12.5C0 5.5964 5.596 0 12.5 0C19.404 0 25 5.5964 25 12.5C25 12.8632 24.984 13.223 24.954 13.5784C24.898 14.2299 24.299 14.6754 23.649 14.6085L22.442 14.4844C21.702 14.4082 21.199 13.7045 21.238 12.9616C21.246 12.8088 21.25 12.6549 21.25 12.5C21.25 7.6675 17.332 3.75 12.5 3.75C7.668 3.75 3.75 7.6675 3.75 12.5C3.75 17.3325 7.668 21.25 12.5 21.25C14.108 21.25 15.614 20.8164 16.909 20.0596C17.636 19.6345 18.632 19.8473 18.976 20.6161L19.452 21.6772Z",
    fill: "#C4D6B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 18.75C15.952 18.75 18.75 15.9518 18.75 12.5C18.75 9.0482 15.952 6.25 12.5 6.25C9.048 6.25 6.25 9.0482 6.25 12.5C6.25 15.9518 9.048 18.75 12.5 18.75ZM12.5 15.625C14.226 15.625 15.625 14.2259 15.625 12.5C15.625 10.7741 14.226 9.375 12.5 9.375C10.774 9.375 9.375 10.7741 9.375 12.5C9.375 14.2259 10.774 15.625 12.5 15.625Z",
    fill: "#F53C74"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.312 20.25C22.59 20.25 23.625 19.2147 23.625 17.9375C23.625 16.6603 22.59 15.625 21.312 15.625C20.035 15.625 19 16.6603 19 17.9375C19 19.2147 20.035 20.25 21.312 20.25Z",
    fill: "#C4D6B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyIcon);
export default __webpack_public_path__ + "static/media/my-icon.43927b5281e53e77eede70ada6c08464.svg";
export { ForwardRef as ReactComponent };